import React from "react";

import {QRCode} from 'react-qrcode-logo';
import {getAddressTitle} from "./Address";
import {useListContext} from "react-admin";
import {makeStyles} from "@material-ui/core/styles";


const AddressQR = ({title, address, size}) => {
    if (!address || !address.id) {
        return null
    }
    const url = window.location.origin
    const params = encodeURIComponent(JSON.stringify({addressId: address.id}));

    if(!size || size < 2){
        size = 2;
    }

    return address && address.id &&
        <div
            key={address?.id}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: 12,
                border: "1px solid #e0e0e0",
                borderRadius: 4,
                pageBreakInside: "avoid",
                breakInside: "avoid",
                width: `${size}cm`,
                height: `${size}cm`,
            }}
        >
            <span style={{
                color: "#ce1c4c",
                fontWeight: "bold",
                fontSize: `${size * 0.8 / 10}cm`,
            }}>
                {title || "FERDO upratovací servis"}
            </span>
            <QRCode
                size={size * 0.75 * 37.8}
                style={{position: "relative"}}
                value={url + '/#/qr?filter=' + params}
                logoImage={"ferdo_logo.png"}
                logoWidth={(size * 0.8 * 37.8) * 0.7}
                logoOpacity={0.5}
                qrStyle={"dots"}
                eyeRadius={[
                    [10, 10, 0, 10], // top/left eye
                    [10, 10, 10, 0], // top/right eye
                    [10, 0, 10, 10], // bottom/left
                ]}
            />
            <span style={{
                fontSize: `${size / 15}cm`,
            }}>{getAddressTitle(address)}</span>
        </div>
}
const expandAddresses = (data, ids) => {
    if (!data || !ids)
        return null;

    const addresses = [];

    ids.forEach(id => {
        const partner = data[id];

        (partner?.addresses || []).forEach(address => {
            addresses.push({
                partnerName: partner?.name,
                partnerShortName: partner?.shortName,
                ico: partner?.ico,
                address: address?.address
            });
        });
    });

    return addresses;
}

const useStyles = makeStyles((theme) => ({
    printContent: props => ({
        display: 'none', // default hidden

        '@media print': {
            display: 'ruby',
            gridTemplateColumns: `repeat(auto-fill, minmax(0, ${props.size}cm))`,
            gap: "8px",
            width: "100%"
        },
    }),
}));

export const HiddenAddressPrintGrid = ({printRef, qrSize}) => {
    const {data, ids} = useListContext();
    const addressData = expandAddresses(data, ids);
    const classes = useStyles({qrSize});

    return <div
        ref={printRef}
        className={classes.printContent}
    >
        {addressData && addressData.map(item => (
            <AddressQR address={item.address} size={qrSize}/>
        ))}
    </div>
};

export default AddressQR;